var _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8, _path9, _path10;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgFragileIcon(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 69,
    height: 70,
    viewBox: "0 0 69 70",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M34.5 68.0045C53.0015 68.0045 68 53.005 68 34.5022C68 15.9995 53.0015 1 34.5 1C15.9985 1 1 15.9995 1 34.5022C1 53.005 15.9985 68.0045 34.5 68.0045Z",
    fill: "white",
    stroke: "#231F20",
    strokeWidth: 2,
    strokeMiterlimit: 10
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M35.6484 21.9142C35.6484 21.9142 37.5986 14.8787 45.1002 14.1728C45.1002 14.1728 51.3815 13.5985 54.2051 20.1912C54.2051 20.1912 45.6386 13.4549 35.6484 21.9142Z",
    fill: "#231F20"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M47.3506 42.3748C51.9495 42.3748 55.6777 37.2375 55.6777 30.9003C55.6777 24.5631 51.9495 19.4258 47.3506 19.4258C42.7516 19.4258 39.0234 24.5631 39.0234 30.9003C39.0234 37.2375 42.7516 42.3748 47.3506 42.3748Z",
    fill: "white",
    stroke: "black",
    strokeWidth: 1.3,
    strokeMiterlimit: 10
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M45.9624 39.6486C48.2619 39.6486 50.126 37.0773 50.126 33.9053C50.126 30.7334 48.2619 28.1621 45.9624 28.1621C43.6629 28.1621 41.7988 30.7334 41.7988 33.9053C41.7988 37.0773 43.6629 39.6486 45.9624 39.6486Z",
    fill: "black"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M33.0996 21.8068C33.0996 21.8068 31.1494 14.7713 23.6478 14.0654C23.6478 14.0654 17.3665 13.4911 14.543 20.0838C14.543 20.0838 23.1094 13.3475 33.0996 21.8068Z",
    fill: "#231F20"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M21.3994 42.2674C25.9984 42.2674 29.7266 37.1301 29.7266 30.7929C29.7266 24.4557 25.9984 19.3184 21.3994 19.3184C16.8005 19.3184 13.0723 24.4557 13.0723 30.7929C13.0723 37.1301 16.8005 42.2674 21.3994 42.2674Z",
    fill: "white",
    stroke: "black",
    strokeWidth: 1.3,
    strokeMiterlimit: 10
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M22.7749 39.5392C25.0744 39.5392 26.9385 36.9679 26.9385 33.796C26.9385 30.6241 25.0744 28.0527 22.7749 28.0527C20.4754 28.0527 18.6113 30.6241 18.6113 33.796C18.6113 36.9679 20.4754 39.5392 22.7749 39.5392Z",
    fill: "black"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    d: "M23.877 55.9671L47.4227 51.6836",
    stroke: "black",
    strokeWidth: 2,
    strokeMiterlimit: 10
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    d: "M25.6465 4.03906L23.8159 9.78231H17.1997L14.5436 15.2862L8.89648 14.0538",
    stroke: "#00ADEB",
    strokeWidth: 1.3,
    strokeMiterlimit: 10
  })), _path10 || (_path10 = /*#__PURE__*/React.createElement("path", {
    d: "M67.1266 34.3704L62.1136 31.0441L63.9202 24.6787L59.3379 20.6225L62.0657 15.5254",
    stroke: "#00ADEB",
    strokeWidth: 1.3,
    strokeMiterlimit: 10
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgFragileIcon);
export default __webpack_public_path__ + "static/media/fragile-icon.c7b1b11bc0278ee9bf703e41c8020707.svg";
export { ForwardRef as ReactComponent };